<template>
  <div class="container">
    <h3 class="center title">“中国设计年度十大事件”推荐表</h3>
    <div class="manage">
      <router-link class="bold" to="/top_events/mylist">管理推荐表</router-link>
    </div>
    <Form ref="form" :model="info" :rules="rules" hide-required-mark class="formStyle">
      <FormItem prop="recommender" label="推荐人/单位">
        <Input type="text" v-model="info.recommender"></Input>
      </FormItem>
      <FormItem prop="applicant" label="申报单位">
        <Input type="text" v-model="info.applicant"></Input>
      </FormItem>
      <FormItem prop="type" label="门类">
        <Select v-model="info.type">
          <Option value="设计学术理论研究与学科建设">设计学术理论研究与学科建设</Option>
          <Option value="设计类政策">设计类政策</Option>
          <Option value="提升中国设计的全球影响力事件">提升中国设计的全球影响力事件</Option>
          <Option value="产业、企业、产品典型">产业、企业、产品典型</Option>
          <Option value="设计公益">设计公益</Option>
          <Option value="其他">其他</Option>
        </Select>
      </FormItem>
      <FormItem prop="otherType" label="其他门类" v-if="info.type=='其他'">
        <Input type="text" :maxlength="20" v-model="info.otherType" placeholder="20字以内"></Input>
      </FormItem>
      <FormItem prop="eventName" label="事件名称">
        <Input type="text" :maxlength="20" v-model="info.eventName" placeholder="20字以内"></Input>
      </FormItem>
      <FormItem prop="person" label="负责人">
        <Input type="text" v-model="info.person"></Input>
      </FormItem>
      <FormItem prop="phone" label="联系电话">
        <Input type="tel" v-model="info.phone"></Input>
      </FormItem>
      <FormItem prop="address" label="通讯地址">
        <Input type="text" v-model="info.address"></Input>
      </FormItem>
      <FormItem prop="main" label="主要事迹">
        <Input type="textarea" :autosize="{minRows: 4}" :maxlength="300" v-model="info.main" placeholder="300字以内"></Input>
      </FormItem>
      <FormItem prop="reason" label="推荐理由">
        <Input type="textarea" :autosize="{minRows: 4}" :maxlength="50" v-model="info.reason" placeholder="50字以内"></Input>
      </FormItem>
      <div class="fileWrap">
        <p class="ivu-form-item-label">上传盖章的纸质表格照片或者扫描件（可上传格式：JPG，PNG）</p>
      </div>
      <div>
        <Upload
          ref="file"
          :action="imgApi"
          :headers="{Authorization: token}"
          name="picture"
          :data="{applyType: 'CERTIFICATE'}"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload" 
          :on-format-error="handleFormatError"
          :on-error="handleError"
          :on-exceeded-size="handleSize"
          :on-progress="handleProgress"
          :max-size="5120"
          accept="image/jpg, image/png, image/jpeg">
            <Button class="defaultBtn size12" shape="circle">上传文件</Button>
        </Upload>
      </div>
      <div class="imgWrap" >
        <template v-if="imgUrl">
          <img class="img" :src="getImageUrl(imgUrl, 'small')" alt="">
          <div class="imgMask">
            <Icon type="ios-close-circle-outline" class="delImg" @click="removeImg"/>
          </div>
        </template>
        <template v-if="fileUpload.showProgress">
          <Progress class="progress" :percent="fileUpload.percentage" hide-info></Progress>
        </template>
      </div>
    </Form>
    <Button shape="circle" long :loading="submitting" class="defaultBtn submitBtm" @click="submit">提交</Button>
  </div>
</template>

<script>
import { baseUrl } from "@/config/env";
import competitionService from "@/api/competition";
export default {
  data() {
    return {
      submitting: false,
      info: {},
      rules: {
        recommender: [
          { required: true, message: "请输入推荐人/单位", trigger: "blur" }
        ],
        applicant: [
          { required: true, message: "请输入申报单位", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择门类", trigger: "change,blur" }
        ],
        eventName: [
          { required: true, message: "请输入事件名称", trigger: "blur" }
        ],
        person: [{ required: true, message: "请输入负责人", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        address: [
          { required: true, message: "请输入通讯地址", trigger: "blur" }
        ],
        main: [{ required: true, message: "请输入主要事迹", trigger: "blur" }],
        reason: [{ required: true, message: "请输入推荐理由", trigger: "blur" }]
      },

      imgApi: `${baseUrl}picture/upload`,
      token: this.$store.getters.token,
      fileUpload: { showProgress: false, percentage: 0 },
      imgUrl: ""
    };
  },
  mounted() {
    // console.log(this.$route.path)
    if (!this.gIsLogin()) {
      this.$Modal.info({
        title: "提示",
        content: "登录后才能提交推荐表",
        okText: "去登录",
        onOk: () => {
          this.$router.push(
            `/login?fromUrl=/top_events/form`
          );
        }
      });
      return;
    }
  },
  methods: {
    // 上传图片成功
    handleSuccess(res) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage);
      } else {
        let data = res.data;
        this.imgUrl = data.path;
        this.fileUpload.showProgress = false;
        this.fileUpload.percentage = 0;
        this.$forceUpdate();
      }
    },
    handleBeforeUpload(file) {
      let check = true;
      if (file.size == 0) {
        check = false;
      }
      this.fileUpload.showProgress = true;
      return check;
    },
    handleProgress(event) {
      this.fileUpload.percentage = event.percent;
    },
    // 文件超出最大值5M
    handleSize() {
      this.$Message.info("文件超过最大值5M，请重新选择！");
      this.fileUpload.showProgress = false;
    },
    // 文件格式错误提示
    handleFormatError(file) {
      this.$Message.error(`文件${file.name}格式错误`);
      this.fileUpload.showProgress = false;
    },
    // 错误提示
    handleError(error) {
      this.$Message.error("服务器错误" + error);
      this.fileUpload.showProgress = false;
    },
    // 删除文件
    removeImg() {
      this.imgUrl = "";
    },
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.push("/login");
    },
    // 提交表单
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(!this.imgUrl){
            this.$Message.error("请上传盖章文件");
            return
          }
          this.submitting = true;
          let condition = Object.assign({}, {chargePerson: this.info.person, mainEvent: this.info.main, imgPath: this.imgUrl}, this.info)
          competitionService.saveTopEvent(condition).then(res => {
            this.submitting = false;
            if (res.errorNo == 0) {
              this.$Message.info('提交成功')
              this.$router.push("/top_events/mylist");
            } else {
              this.$Message.error(res.errorMessage);
            }
          })
          .catch(() => {
            // this.$Message.error(err.message)
            this.submitting = false;
            this.$Message.error("连接服务器失败，请稍后再试");
          });

        } else {
          this.$Message.error("信息未正确填写完整");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: 15px 0 20px;
}
.fileWrap {
  height: 22px;
}
.imgWrap {
  position: relative;
  width: 100px;
  // height: 100px;
  margin-top: 10px;
  margin-right: 15px; // margin-bottom: 24px;
  display: inline-block;
  vertical-align: top;
  // background: rgba($color: #000000, $alpha: 0.1);
  .img {
    width: 100px;
    // height: 100px;
  }
  .imgMask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.35);
    color: #dedede;
    .delImg {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
      font-size: 20px;
    }
  }
  .progress{
    position: absolute;
    left: 0;
  }
}
.imgWrap:hover .imgMask {
  display: inline-block;
}
.submitBtm {
  margin-top: 30px;
}
.manage{
  padding: 5px;
  text-align: right;
}
</style>
